import { useCallback, useEffect, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import { styled, useTheme } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import DrawIcon from '@mui/icons-material/Draw';
import NightsStayIcon from '@mui/icons-material/NightsStay';
import CloseIcon from '@mui/icons-material/Close';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';

import * as React from 'react';
import Switch from '@mui/material/Switch';

import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import Films from './pages/Films';
import Paintings from './pages/Paintings';
import Books from './pages/Books';
import Writing from './pages/Writing';
import Sketching from './pages/Sketching';
import Stories from './pages/Stories';
import SecretStuff from './pages/SecretStuff';

import { useLocation } from 'react-router-dom';


import {
  AppBar as MuiAppBar,
  Box,
} from "@mui/material";


import './App.css';

const drawerWidth = 200;

const Main = styled('main')(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
}));


const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));


function App() {
  const location = useLocation();

  const getParticleColor = (path) => {
    switch (path) {
      case '/films':
        return "#f1c40f";
      case '/paintings':
        return "#1abc9c";
      case '/books':
        return "#3498db";
      case '/writing':
        return "#e91e63";
      case '/sketching':
        return "#bdc3c7";
      case '/stories':
        return "#e67e22";
      case '/secret-stuff':
        return "#a020f0";
      case '/':
      default:
        return ["#ff0000", "#ff6600", "#ff9900"];
    }
  };

  const [init, setInit] = useState(false);
  const theme = useTheme();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [openStuffILike, setOpenStuffILike] = useState(false);
  const handleClickStuffILike = () => { setOpenStuffILike(!openStuffILike) };

  const [openStuffIDo, setOpenStuffIDo] = useState(false);
  const handleClickStuffIDo = () => { setOpenStuffIDo(!openStuffIDo) };


  const handleDrawerOpen = () => { setDrawerOpen(true) };
  const handleDrawerClose = () => { setDrawerOpen(false) };

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesLoaded = (container) => {
    console.log(container);
  };
  
  return (

      <div style={{ width: '100%', height: '100' }}>
        {init && <Particles
          id="tsparticles"
          particlesLoaded={particlesLoaded}
          options={{
            background: {
              color: {
                value: '#000000', // sfondo scuro come nel demo fire
              },
            },
            fullScreen: {
              enable: true,
              zIndex: -1,
            },
            particles: {
              number: {
                value: 150,
                density: {
                  enable: true,
                  area: 800,
                },
              },
              color: {
                value: getParticleColor(location.pathname), //["#ff0000", "#ff6600", "#ff9900"], // sfumature del fuoco
              },
              shape: {
                type: "circle",
              },
              opacity: {
                value: 0.6,
                random: true,
                animation: {
                  enable: true,
                  speed: 0.5,
                  minimumValue: 0.1,
                  sync: false,
                },
              },
              size: {
                value: { min: 1, max: 4 },
                random: true,
              },
              move: {
                enable: true,
                speed: 1,
                direction: "top",
                random: false,
                straight: false,
                outModes: {
                  default: "out",
                },
                attract: {
                  enable: false,
                },
              },
            },
            emitters: {
              direction: "top",
              rate: {
                delay: 0.1,
                quantity: 2,
              },
              size: {
                width: 100,
                height: 0,
              },
              position: {
                x: 50,
                y: 100,
              },
            },
            detectRetina: true,
          }}
        />
        }

        <Box sx={{ display: 'flex', position: 'relative', zIndex: 1 }}>
          <CssBaseline />
          <AppBar position="fixed" open={drawerOpen} sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}>

            <Toolbar sx={{ backgroundColor: 'rgba(0, 0, 0, 0.66)' }}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={{ mr: 2, ...(drawerOpen && { display: 'none' }) }}
              >
                <MenuIcon />
              </IconButton>
              <Typography
                variant="h6"
                noWrap
                component={NavLink}
                to="/"
                sx={{ textDecoration: 'none', color: 'inherit' }}
              >
                Home
              </Typography>

            </Toolbar>
          </AppBar>

          <Drawer
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              '& .MuiDrawer-paper': {
                width: drawerWidth,
                boxSizing: 'border-box',
                backgroundColor: 'rgba(37, 23, 0, 0.98)',
                color: 'white'
              },
              '& .MuiListItemIcon-root': {
                color: 'white', // icone bianche
              },
            }}
            variant="temporary"
            anchor="left"
            open={drawerOpen}
            onClose={handleDrawerClose} 
          >
            <DrawerHeader>
              <IconButton onClick={handleDrawerClose} sx={{ color: 'white' }}>
                <CloseIcon /> {/** ChevronLeftIcon */}
              </IconButton>
            </DrawerHeader>
            <Divider />
            <List>

              <ListItem disablePadding>
                <ListItemButton onClick={handleClickStuffILike}>
                  <ListItemIcon>
                    <FavoriteBorderIcon />
                  </ListItemIcon>
                  <ListItemText primary="Stuff I like" />
                  {openStuffILike ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
              <Collapse in={openStuffILike} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton component={NavLink} to="/films" onClick={handleDrawerClose} sx={{ pl: 4 }}>
                    <ListItemText primary="Films" />
                  </ListItemButton>
                  <ListItemButton component={NavLink} to="/paintings" onClick={handleDrawerClose} sx={{ pl: 4 }}>
                    <ListItemText primary="Paintings" />
                  </ListItemButton>
                  <ListItemButton component={NavLink} to="/books" onClick={handleDrawerClose} sx={{ pl: 4 }}>
                    <ListItemText primary="Books" />
                  </ListItemButton>
                </List>
              </Collapse>

              <ListItem disablePadding>
                <ListItemButton onClick={handleClickStuffIDo}>
                  <ListItemIcon>
                    <DrawIcon /> {/* oppure BrushIcon */}
                  </ListItemIcon>
                  <ListItemText primary="Stuff I do" />
                  {openStuffIDo ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>

              <Collapse in={openStuffIDo} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton component={NavLink} to="/writing" onClick={handleDrawerClose} sx={{ pl: 4 }}>
                    <ListItemText primary="Writing" />
                  </ListItemButton>
                  <ListItemButton component={NavLink} to="/sketching" onClick={handleDrawerClose} sx={{ pl: 4 }}>
                    <ListItemText primary="Sketching" />
                  </ListItemButton>
                  <ListItemButton component={NavLink} to="/stories" onClick={handleDrawerClose} sx={{ pl: 4 }}>
                    <ListItemText primary="Stories" />
                  </ListItemButton>
                </List>
              </Collapse>



              <ListItem key={'Secret stuff'} disablePadding>
                <ListItemButton component={NavLink} to="/secret-stuff" onClick={handleDrawerClose}>
                  <ListItemIcon>
                    <NightsStayIcon />
                  </ListItemIcon>
                  <ListItemText primary={'Secret stuff'} />
                </ListItemButton>
              </ListItem>

            </List>
          </Drawer>

          <Main open={drawerOpen}>
            <DrawerHeader />
            <Routes>
              <Route path="/" element={
                <>
                  <Typography variant="h5" color="white" gutterBottom>
                    Eilà!
                  </Typography>
                  <Typography variant="h5" color="white" gutterBottom>
                    Se ti trovi qui probabilmente ti sei perso.
                  </Typography>
                  <Typography variant="body1" color="white" sx={{mt:3}}>
                    In caso contrario... sentiti libero di curiosare in giro.
                  </Typography>
                  {/* Accordion iniziali */}
                </>
              } />
              <Route path="/films" element={<Films />} />
              <Route path="/paintings" element={<Paintings />} />
              <Route path="/books" element={<Books />} />
              <Route path="/writing" element={<Writing />} />
              <Route path="/sketching" element={<Sketching />} />
              <Route path="/stories" element={<Stories />} />
              <Route path="/secret-stuff" element={<SecretStuff />} />
            </Routes>
           
          </Main>


        </Box>

      </div>
  );
}

export default App;
